import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, lang, toggleLanguage } = useLanguage();

  return (
    <footer className="bg-brand-darker border-t border-brand-border py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-start">
        <div>
          <a href="#" className="text-2xl font-bold text-brand-textHeading tracking-tight mb-4 inline-block">
            {t.footer.brand}<span className="text-brand-accent">.</span>
          </a>
          <p className="text-brand-textMuted text-sm mb-6">
            {t.footer.tagline1} <br />
            {t.footer.tagline2}
          </p>

          <a 
            href="https://www.ivmh.dk/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-3 mt-8 grayscale hover:grayscale-0 transition-all duration-300 group"
          >
            <img 
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuUoUeWuh3wDy93rBM4HBfkSdqgseNud0cHg&s" 
              alt="Iværksættere med handicap" 
              className="h-10 w-auto rounded"
            />
            <span className="text-xs font-semibold text-brand-textMuted group-hover:text-brand-text transition-colors">
              {t.footer.ivmh_text}
            </span>
          </a>

          <div className="flex flex-col gap-2 text-xs font-medium text-brand-textMuted mt-8">
            <a 
              href="https://legal.konsulentbixen.dk/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-brand-accent transition-colors"
            >
              {t.footer.terms}
            </a>
            <a 
              href="https://legal.konsulentbixen.dk/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-brand-accent transition-colors"
            >
              {t.footer.privacy}
            </a>
          </div>
        </div>

        <div className="flex flex-col md:items-end gap-6">
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-medium text-brand-text md:justify-end">
            <a href="#about" className="hover:text-brand-accent transition-colors">{t.nav.about}</a>
            <a href="#services" className="hover:text-brand-accent transition-colors">{t.nav.services}</a>
            <a href="#projects" className="hover:text-brand-accent transition-colors">{t.nav.projects}</a>
            <a href="https://shop.konsulentbixen.dk/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent transition-colors">{t.nav.shop}</a>
            <a href="#contact" className="hover:text-brand-accent transition-colors">{t.nav.contact}</a>
          </div>

          <div className="flex items-center gap-3 text-xs font-semibold">
            <button 
              onClick={() => toggleLanguage('da')}
              className={`px-3 py-1.5 rounded transition-colors ${lang === 'da' ? 'bg-brand-card text-white border border-brand-border' : 'text-brand-textMuted hover:text-white'}`}
            >
              Dansk
            </button>
            <button 
              onClick={() => toggleLanguage('en')}
              className={`px-3 py-1.5 rounded transition-colors ${lang === 'en' ? 'bg-brand-card text-white border border-brand-border' : 'text-brand-textMuted hover:text-white'}`}
            >
              English
            </button>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 mt-12 pt-8 border-t border-brand-border/50 text-center text-xs text-brand-textMuted">
        © {new Date().getFullYear()} Konsulentbixen. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;